import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../../utils/api";

const AccountBalance = () => {
	const [data, setData] = useState([]);

	useEffect(() => {
		const fetchMonthlyData = async () => {
			try {
				const res = await api.get(`/money/AccountBalance/`);
				setData(res.data);
				//setData(res.data);
			} catch (err) {
				console.log(err);
			}
		};
		fetchMonthlyData();
	});

	const handleDelete = async (id) => {
		try {
			await api.delete(`/money/accountBalance/${id}`);
			setData((prev) => prev.filter((item) => item.id !== id));
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<section className="lavella page account-balance">
			<div className="cont">
				<div className="links">
					<Link to="/dashboard" style={{ marginBottom: "10px" }} className="l-btn">
						Back
					</Link>
					<Link to="/addAccountBalance" className="l-btn">
						Add Single
					</Link>
					<Link to={`/addAccountBalances/${"NL"}`} className="l-btn">
						Add NL
					</Link>
					<Link to={`/addAccountBalances/${"Erin"}`} className="l-btn">
						Add Erin
					</Link>
				</div>

				<div className="table horizontal">
					{data &&
						data.map((item) => (
							<div className={item.highlight === "x" ? "row highlight" : "row"} key={item.id}>
								<div className="col hd">
									<p className="">{item.account}</p>
								</div>
								<div className="col">
									<p className="">${item.value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
								</div>
								<div className="col">
									<p>{new Date(new Date(item.date_edited).getTime() - 4 * 60 * 60 * 1000).toLocaleString("en-US", { timeZone: "America/New_York", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "numeric", hour12: true })}</p>
								</div>
								<div className="col total">
									<Link to={`/updateAccountBalance/${item.id}`} className="l-btn secondary">
										Edit
									</Link>
									<a className="l-btn secondary" onClick={() => handleDelete(item.id)}>
										Delete
									</a>
								</div>
							</div>
						))}
				</div>
			</div>
		</section>
	);
};

export default AccountBalance;
